import {loadStateFromLS} from 'app/context/context';
import {Api} from './admin-gw';
import {Api as ScoringApi} from './scoring-gw';

export const CApi = () =>
    new Api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {Authorization: `Bearer ${loadStateFromLS().token}`}
    });

export const SApi = () =>
        new ScoringApi({
            baseURL: process.env.REACT_APP_API_BASE_URL,
            headers: {Authorization: `Bearer ${loadStateFromLS().token}`}
        });
